export const COMMON_LANGUAGES = ['en', 'es', 'fr', 'de', 'it', 'pt', 'ja', 'ko', 'zh', 'ru'] as const

export const KNOWN_LANGUAGE_CODES = [
  'en', 'es', 'fr', 'de', 'it', 'pt', 'ja', 'ko', 'zh', 'ru',
  'ar', 'hi', 'nl', 'sv', 'da', 'no', 'fi', 'pl', 'tr', 'th', 'id', 'vi', 'cs', 'el', 'he', 'hu', 'ro', 'uk',
  'bn', 'ta', 'te', 'ml', 'mr', 'gu', 'kn', 'pa', 'tl', 'ms', 'fa', 'ur', 'cn',
] as const

export const RECOMMENDED_DIMENSIONS = { width: 1920, height: 1080 } as const
